import { CircularProgress } from "@mui/material";

function Loader({ size = 40 }) {
    return <CircularProgress color='primary' size={size} />;
}

export default Loader;
